export default __webpack_public_path__ + "static/19-124a553563419519c9adb43fc530c76a.jpg";